import _ from 'lodash'

const searchValue = (options, query) => {
  const re = new RegExp(_.escapeRegExp(query), 'i')
  return options.filter(opt => re.test(opt.value))
}

export default searchValue
